import { lazy, Suspense } from 'react'
import { Helmet } from 'react-helmet'
import { Route, Routes } from 'react-router-dom'
import PageLoading from '../../components/PageLoading'

const AccessibilityCommitment = lazy(() => import('./AccessibilityCommitment'))
const AffiliateHub = lazy(() => import('./Affiliatehub'))
const CopyrightPolicy = lazy(() => import('./legal/CopyrightPolicy'))
const FacebookTransfer = lazy(() => import('./FacebookTransfer'))
const FreeTrialSignup = lazy(() => import('./offer/FreeTrialSignup'))
const FreeTrialTY = lazy(() => import('./confirmation/FreeTrialTY'))
const GetTheApp = lazy(() => import('./confirmation/GetTheApp'))
const Homepage = lazy(() => import('./homepage'))
const Layout = lazy(() => import('./components/Layout'))
const MobileApp = lazy(() => import('./offer/MobileApp'))
const NotFound = lazy(() => import('./NotFound'))
const NotFoundComponent = lazy(() => import('../../components/NotFound'))
const OpeningUXDev = lazy(() => import('./opportunities/OpeningUXDev'))
const PrivacyPolicy = lazy(() => import('./legal/PrivacyPolicy'))
const SignUp = lazy(() => import('./SignUp'))
const StartUploading = lazy(() => import('./confirmation/StartUploading'))
const TermsOfService = lazy(() => import('./legal/TermsOfService'))
const BiometricPolicy = lazy(() => import('./legal/BiometricPolicy'))

export default function Router() {
  return (
    <>
      <Helmet>
        <link
          rel="preload"
          as="image"
          type="image/webp"
          imageSrcSet="//content.photobucket.com/img/homepage/hero-slide_memories_w_200.webp 200w,
            //content.photobucket.com/img/homepage/hero-slide_memories_w_513.webp 513w,
            //content.photobucket.com/img/homepage/hero-slide_memories_w_695.webp 695w,
            //content.photobucket.com/img/homepage/hero-slide_memories_w_870.webp 870w,
            //content.photobucket.com/img/homepage/hero-slide_memories_w_1061.webp 1061w,
            //content.photobucket.com/img/homepage/hero-slide_memories_w_1292.webp 1292w,
            //content.photobucket.com/img/homepage/hero-slide_memories_w_1491.webp 1491w,
            //content.photobucket.com/img/homepage/hero-slide_memories_w_1536.webp 1536w"
        />
      </Helmet>
      <Layout>
        <Suspense fallback={<PageLoading />}>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="accessibility-commitment" element={<AccessibilityCommitment />} />
            <Route path="account-verified/get-the-app" element={<GetTheApp />} />
            <Route path="account-verified/start-uploading" element={<StartUploading />} />
            <Route path="affiliate-hub" element={<AffiliateHub />} />
            <Route path="m/facebook-transfer" element={<FacebookTransfer />} />
            <Route path="offer/app" element={<MobileApp />} />
            <Route path="offer/pick-your-plan" element={<SignUp />} />
            <Route path="offer/trial" element={<FreeTrialSignup />} />
            <Route path="opportunities/ux-developer" element={<OpeningUXDev />} />
            <Route path="p/error" element={<NotFound />} />
            <Route path="legal/copyright-policy" element={<CopyrightPolicy />} />
            <Route path="legal/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="legal/terms-of-service" element={<TermsOfService />} />
            <Route path="legal/biometric-information-privacy-policy" element={<BiometricPolicy />} />
            <Route path="thank-you/free-trial" element={<FreeTrialTY />} />
            <Route path="signup" element={<SignUp />} />
            <Route path="*" element={<NotFoundComponent />} />
          </Routes>
        </Suspense>
      </Layout>
    </>
  )
}
